export default window._cmsContent['whd/applications-closed']